import React from "react"
import parse from "html-react-parser"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"

import * as S from "./custom-accordion.styles"

const CustomAccordion = ({ expanded, question, handleChange, answer }) => {
  return (
    <S.CustomAccordion
      expanded={expanded === `panel${question}`}
      onChange={handleChange(`panel${question}`, question)}
    >
      <S.CustomAccSummary
        // expandIcon={expanded === `panel${question}` ? <S.Icon /> : <S.Icon />}>
        // expandIcon={
        //   <S.Icon className={expanded === `panel${question}` ? "active" : ""} />
        // }
        expandIcon={<KeyboardArrowDownIcon />}
        className={expanded === `panel${question}` ? "active" : ""}
      >
        {question}
      </S.CustomAccSummary>
      <S.CustomAccDetails>{parse(answer)}</S.CustomAccDetails>
    </S.CustomAccordion>
  )
}

export default CustomAccordion
